import { render, staticRenderFns } from "./v-radio-field.vue?vue&type=template&id=2771463f&scoped=true&"
import script from "./v-radio-field.vue?vue&type=script&lang=js&"
export * from "./v-radio-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771463f",
  null
  
)

export default component.exports